import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
// import { Link } from 'react-router-dom'
import { Row, Col, Button, Form, Toast } from "react-bootstrap";
import { IoIosClose, IoMdDoneAll } from "react-icons/io";
import { _HttpServices } from "../../../_services/_HttpServices";
import { useHistory } from "react-router-dom";
import Loader from './../../../components/Loader';

const CommunicationConfiguration = (props, { dispatch }) => {
  const [validated, setValidated] = useState(false);
  const [submitBtnDisable, setSubmitBtnDisable] = useState(true);
  const editing = props.editing;
  const view = props.viewTask;
  const [tasksData, setTasksData] = useState(null);
  const [submitAction, setSubmitAction] = useState(null);
  const checkboxesObj = {
    checkEmail:
      (editing || view) && props.communicationConfig
        ? props.communicationConfig.IsEmail
        : false,
    HTTP:
    (editing || view) && props.communicationConfig
        ? props.communicationConfig.IsHTTP
        : false,
    FTP:
    (editing || view) && props.communicationConfig
        ? props.communicationConfig.IsFTP
        : false,
    SFTP:
    (editing || view) && props.communicationConfig
        ? props.communicationConfig.IsSFTP
        : false,
  };
  const [checkedItems, setCheckedItems] = useState(checkboxesObj);
  const [vendorData, setVendorData] = useState([]);
  const [dropDownData, SetDropDownData] = useState([]);
  const [userName, setUserName] = useState("");
  const [disableBtn, setDisableBtn] = useState(true);
  const [showToaster, setShowToaster] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const task = props.task;
  const [loader,setLoader] = useState(false);

  const initialState = {
    ClientID: task.ClientId,
    IsEmail: false,
    IsHTTP: false,
    IsFTP: false,
    IsSFTP: false,
    Email: "",
    ServiceTaskId: "",
    ChannelID: "",
    CreatedOn: moment(new Date()).format("L"),
    FTPTargetNetwork: "",
    FTPUserName: "",
    FTPPassword: "",
    FTPPrivateKeyPath: "",
    FTPInsidewhichfolder: "",
    FTPPortNumber: "",
    SFTPTargetNetwork: "",
    SFTPUserName: "",
    SFTPPassword: "",
    SFTPSshHostkeyfingerprint: "",
    SFTPPortNumber: "",
    SFTPInsideWhichFolder: "",
    httpTargetNetwork: "",
    httpUserName: "",
    httpPassword: "",
    httpPortNumber: "",
    // ServiceTaskId: "",
    CreatedBy: "",
    AutoApprovedStatusID:true
  };
  const history = useHistory();
  if (editing || view) {
    Object.keys(initialState).map((key) => {
      if(props.communicationConfig){
        if(props.communicationConfig.hasOwnProperty(key) === false){
          props.communicationConfig[key] = "";
        } else if(!props.communicationConfig[key] && key != "AutoApprovedStatusID"){
          props.communicationConfig[key] = "";
        } else if(key === "AutoApprovedStatusID"){
            if(props.communicationConfig["Id"] === 0) {
                if((props.communicationConfig["AutoApprovedStatusID"] === false )){
                  props.communicationConfig["AutoApprovedStatusID"] = true;
                }
                if(props.communicationConfig["ClientID"] === 0 || props.communicationConfig["ClientID"] === "" ){
                  props.communicationConfig["ClientID"] = "The CIBD Distributors";
                }
            }
        }
      }
    });

  }
  const [communication, setCommunication] = useState(
    (editing || view) ? props.communicationConfig : initialState
  );
  useEffect(() => {
    setCommunication((values) => ({
      ...values,
      // ClientID: task.ClientId,
      ClientID: "The CIBD Distributors",
      ServiceTaskId : task.Id
    }));
  }, [props]);

  // Get vendor list
  const getVendorData = async () => {
    await _HttpServices
      .getData("api/inbound/VendorList")
      .then((data) => {
        setVendorData(data.data);
      })
      .catch((e) => {setLoader(false);});
  };
  const getDropDownData = () => {
    _HttpServices
      .getData("api/Services/NewTask")
      .then((data) => {
        SetDropDownData(data.data);
      })
      .catch((e) => {setLoader(false);});
  };
  const getTasksData = async() => {
    await _HttpServices
          .getData("api/Services/All")
          .then((data) => {
            let outboundTasks = [];
            outboundTasks = data.data.filter(resp => resp.FileSourceTypeId == 2)
            setTasksData(outboundTasks);
          }).catch((e) => {setLoader(false)})
  }
  const getTaskByName = async () => {
    await _HttpServices
      .getData(
        `api/services/ClientConfigurationTaskName?taskname=${task.TaskName}`
      )
      .then( async (data) => {
        communication.ServiceTaskId = data.data[0].Id;
        await setCommunication(communication)
        setLoader(false)
      })
      .catch((e) => {
        setLoader(false)
      });
  }
  useEffect(() => {
    communicationUpdate(communication);
    checkboxUpdate(checkedItems);
  }, [dispatch, task, communication, checkedItems]);
  useEffect(() => {
    setLoader(true)
    getVendorData();
    getDropDownData();
    getTasksData();
    getTaskByName();
    if (localStorage.getItem("userData")) {
      const userData = localStorage.getItem("userData");
      setUserName(JSON.parse(userData).FirstName);
    }
  }, []);

  const restrictFileds = (name, value) => {
    if (
      name === "httpPortNumber" ||
      name === "FTPPortNumber" ||
      name === "SFTPPortNumber"
    ) {
      const re = /^[0-9\b]+$/;
      if (value === "" || re.test(value)) {
        setCommunication((values) => ({
          ...values,
          [name]: value,
        }));
      }
    }
  };
  const communicationUpdate = (communication) => {
    let disabled = true;
    if (checkedItems.checkEmail === true) {
      if (communication.Email.length > 0) {
        if (checkedItems.HTTP === true) {
          disabled =
            communication.httpPassword.length > 0 &&
            communication.httpUserName.length > 0 &&
            communication.httpTargetNetwork.length > 0
              ? false
              : true;
        } else if (checkedItems.FTP === true) {
          disabled =
            communication.FTPTargetNetwork.length > 0 &&
            communication.FTPPassword.length > 0 &&
            communication.FTPUserName.length > 0 &&
            communication.FTPPortNumber.length > 0
              ? false
              : true;
        } else if (checkedItems.SFTP === true) {
          disabled =
            communication.SFTPTargetNetwork.length > 0 &&
            communication.SFTPPassword.length > 0 &&
            communication.SFTPSshHostkeyfingerprint.length > 0 &&
            communication.SFTPPortNumber.toString().length > 0 &&
            communication.SFTPUserName.length > 0
              ? false
              : true;
        } else {
          disabled =
            communication.ChannelID.toString().length > 0 ? false : true;
        }
      }
    } else if (checkedItems.HTTP === true) {
      if (
        communication.httpPassword.length > 0 &&
        communication.httpUserName.length > 0 &&
        communication.httpTargetNetwork.length > 0
      ) {
        if (checkedItems.FTP === true) {
          disabled =
            communication.FTPTargetNetwork.length > 0 &&
            communication.FTPPassword.length > 0 &&
            communication.FTPUserName.length > 0 &&
            communication.FTPInsidewhichfolder.length > 0 &&
            communication.FTPPortNumber.toString().length > 0
              ? false
              : true;
        } else if (checkedItems.SFTP === true) {
          disabled =
            communication.SFTPTargetNetwork.length > 0 &&
            communication.SFTPPassword.length > 0 &&
            communication.SFTPSshHostkeyfingerprint.length > 0 &&
            communication.SFTPPortNumber.toString().length > 0 &&
            communication.SFTPUserName.length > 0
              ? false
              : true;
        } else if (checkedItems.checkEmail === true) {
          disabled = communication.Email.length > 0 ? false : true;
        } else {
          disabled =
            communication.httpPassword.length > 0 &&
            communication.httpUserName.length > 0 &&
            communication.ChannelID.toString().length > 0 &&
            communication.httpTargetNetwork.length > 0
              ? false
              : true;
        }
      } else {
        disabled =
          communication.httpPassword.length > 0 &&
          communication.httpUserName.length > 0 &&
          communication.ChannelID.toString().length > 0 &&
          communication.httpTargetNetwork.length > 0
            ? false
            : true;
      }
    } else if (checkedItems.FTP === true) {
      if (
        communication.FTPTargetNetwork.length > 0 ||
        communication.FTPPassword.length > 0 ||
        communication.FTPUserName.length > 0 ||
        communication.FTPPortNumber.toString().length > 0 ||
        communication.FTPInsidewhichfolder.length > 0
      ) {
        if (checkedItems.SFTP === true) {
          disabled =
            communication.SFTPTargetNetwork.length > 0 &&
            communication.SFTPPassword.length > 0 &&
            communication.SFTPSshHostkeyfingerprint.length > 0 &&
            communication.SFTPPortNumber.toString().length > 0 &&
            communication.SFTPUserName.length > 0
              ? false
              : true;
        } else if (checkedItems.checkEmail === true) {
          disabled = communication.Email.length > 0 ? false : true;
        } else if (checkedItems.HTTP === true) {
          disabled =
            communication.httpPassword.length > 0 &&
            communication.httpUserName.length > 0 &&
            communication.httpTargetNetwork.length > 0
              ? false
              : true;
        } else {
          disabled =
            communication.FTPTargetNetwork.length > 0 &&
            communication.FTPPassword.length > 0 &&
            communication.FTPUserName.length > 0 &&
            communication.FTPInsidewhichfolder.length > 0 &&
            communication.ChannelID.toString().length > 0 &&
            communication.FTPPortNumber.toString().length > 0
              ? false
              : true;
        }
      } else {
        disabled =
          communication.FTPTargetNetwork.length > 0 &&
          communication.FTPPassword.length > 0 &&
          communication.FTPUserName.length > 0 &&
          communication.FTPInsidewhichfolder.length > 0 &&
          communication.ChannelID.toString().length > 0 &&
          communication.FTPPortNumber.toString().length > 0
            ? false
            : true;
      }
    } else if (checkedItems.SFTP === true) {
      if (
        communication.SFTPTargetNetwork.length > 0 ||
        communication.SFTPPassword.length > 0 ||
        communication.SFTPSshHostkeyfingerprint.length > 0 ||
        communication.SFTPPortNumber.toString().length > 0 ||
        communication.SFTPUserName.length > 0
      ) {
        if (checkedItems.checkEmail === true) {
          disabled = communication.Email.length > 0 ? false : true;
        } else if (checkedItems.HTTP === true) {
          disabled =
            communication.httpPassword.length > 0 &&
            communication.httpUserName.length > 0 &&
            communication.httpTargetNetwork.length > 0
              ? false
              : true;
        } else if (checkedItems.FTP === true) {
          disabled =
            communication.FTPTargetNetwork.length > 0 &&
            communication.FTPPassword.length > 0 &&
            communication.FTPUserName.length > 0 &&
            communication.FTPInsidewhichfolder.length > 0 &&
            communication.FTPPortNumber.toString().length > 0
              ? false
              : true;
        } else {
          disabled =
            communication.SFTPTargetNetwork.length > 0 &&
            communication.SFTPPassword.length > 0 &&
            communication.SFTPSshHostkeyfingerprint.length > 0 &&
            communication.SFTPPortNumber.toString().length > 0 &&
            communication.ChannelID.toString().length > 0 &&
            communication.SFTPUserName.length > 0
              ? false
              : true;
        }
      } else {
        disabled =
          communication.SFTPTargetNetwork.length > 0 &&
          communication.SFTPPassword.length > 0 &&
          communication.SFTPSshHostkeyfingerprint.length > 0 &&
          communication.SFTPPortNumber.toString().length > 0 &&
          communication.ChannelID.toString().length > 0 &&
          communication.SFTPUserName.length > 0
            ? false
            : true;
      }
    } else if (communication.ChannelID.toString().length > 0) {
      if (checkedItems.checkEmail === true) {
        disabled = communication.Email.length > 0 ? false : true;
      } else if (checkedItems.HTTP === true) {
        disabled =
          communication.httpPassword.length > 0 &&
          communication.httpUserName.length > 0 &&
          communication.httpTargetNetwork.length > 0
            ? false
            : true;
      } else if (checkedItems.FTP === true) {
        disabled =
          communication.FTPTargetNetwork.length > 0 &&
          communication.FTPPassword.length > 0 &&
          communication.FTPUserName.length > 0 &&
          communication.FTPInsidewhichfolder.length > 0 &&
          communication.FTPPortNumber.toString().length > 0
            ? false
            : true;
      } else if (checkedItems.SFTP === true) {
        disabled =
          communication.SFTPTargetNetwork.length > 0 &&
          communication.SFTPPassword.length > 0 &&
          communication.SFTPSshHostkeyfingerprint.length > 0 &&
          communication.SFTPPortNumber.toString().length > 0 &&
          communication.SFTPUserName.length > 0
            ? false
            : true;
      }
    }
    if(view){
      setDisableBtn(true);  
    }else {
      setDisableBtn(disabled);
    }    
    const emailRe = /^(\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]{2,4}\s*?,?\s*?)+$/;
    const re = /^[0-9\b]+$/;
    if (
      (checkedItems.checkEmail === true && communication.Email === "") ||
      emailRe.test(communication.Email)
    ) {
      // setDisableBtn(true);
      setEmailErr(false);
    } else {
      setEmailErr(true);
    }
  };
  const checkboxUpdate = (checkedItems) => {
    if (checkedItems.checkEmail === true) {
      communication.IsEmail = true;
    } else {
      communication.IsEmail = false;
    }
    if (checkedItems.FTP === true) {
      communication.IsFTP = true;
    } else {
      communication.IsFTP = false;
    }
    if (checkedItems.HTTP === true) {
      communication.IsHTTP = true;
    } else {
      communication.IsHTTP = false;
    }
    if (checkedItems.SFTP === true) {
      communication.IsSFTP = true;
    } else {
      communication.IsSFTP = false;
    }
  };

  // Trim values
  const trimValue = (event) => {
    const { name, value } = event.target;
    setCommunication({ ...communication, [name]: value.trim() });
  };

  // onChange fn
  const handleInputChange = async (event) => {
    const { name, value, checked } = event.target;
    if (
      name !== "checkEmail" &&
      name !== "HTTP" &&
      name !== "SFTP" &&
      name !== "FTP"
    ) {
      if (
        name === "httpPortNumber" ||
        name === "FTPPortNumber" ||
        name === "SFTPPortNumber"
      ) {
        restrictFileds(event.target.name, event.target.value);
      } else if(name === "AutoApprovedStatusID"){
        await setCommunication({ ...communication, [name]: checked });
      }else {
        await setCommunication({ ...communication, [name]: value });
      }
    } else {
      await setCheckedItems({ ...checkedItems, [name]: checked });
      if(name === "FTP"){
        setCommunication((values) => ({
          ...values,
          FTPTargetNetwork: "",
          FTPUserName: "",
          FTPPassword: "",
          FTPPrivateKeyPath: "",
          FTPInsidewhichfolder: "",
          FTPPortNumber: "",
        }));
      } else if(name=="checkEmail"){
        setCommunication((values) => ({
          ...values,
          Email:""
        }));
      } else if(name=="HTTP"){
        setCommunication((values) => ({
          ...values,
          httpTargetNetwork: "",
          httpUserName: "",
          httpPassword: "",
          httpPortNumber: "",
        }));
      } else if(name=="SFTP"){
        setCommunication((values) => ({
          ...values,
          SFTPTargetNetwork: "",
          SFTPUserName: "",
          SFTPPassword: "",
          SFTPSshHostkeyfingerprint: "",
          SFTPPortNumber: "",
          SFTPInsideWhichFolder: "",
        }));
      }
    }
  };

  const addCammunicationSubmitHandler = async (event) => {
    event.preventDefault();
    const form = event.target;
    setLoader(true)
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setLoader(false)
    }
    dropDownData.Client.map((item) => {
      if (item.ClientName === communication.ClientID) {
        communication.ClientID = item.Id;
      }
    });
    communication.CreatedBy = userName;
    communication.CreatedOn =  moment(new Date()).format("L");
    getTaskId();
    setValidated(true);
  };
  //handleOnChangeTask
  const handleOnChangeTask = async (event) => {
    const {name, value, checked } = event.target;
    await setCommunication({ ...communication, [name]: value });
    getTaskDataById(value);
  }
  // Edit fn
  const handleEditInputChange = async (event) => {
    const { name, value, checked } = event.target;
    if (
      name !== "checkEmail" &&
      name !== "HTTP" &&
      name !== "SFTP" &&
      name !== "FTP"
    ) {
      if (
        name === "httpPortNumber" ||
        name === "FTPPortNumber" ||
        name === "SFTPPortNumber"
      ) {
        restrictFileds(event.target.name, event.target.value);
      } else if(name === "AutoApprovedStatusID"){
        await setCommunication({ ...communication, [name]: checked });
      } else {
        await setCommunication({ ...communication, [name]: value });
      }
    } else {
      await setCheckedItems({ ...checkedItems, [name]: checked });
      if(name === "FTP"){
        setCommunication((values) => ({
          ...values,
          FTPTargetNetwork: "",
          FTPUserName: "",
          FTPPassword: "",
          FTPPrivateKeyPath: "",
          FTPInsidewhichfolder: "",
          FTPPortNumber: "",
        }));
      } else if(name=="checkEmail"){
        setCommunication((values) => ({
          ...values,
          Email:""
        }));
      } else if(name=="HTTP"){
        setCommunication((values) => ({
          ...values,
          httpTargetNetwork: "",
          httpUserName: "",
          httpPassword: "",
          httpPortNumber: "",
        }));
      } else if(name=="SFTP"){
        setCommunication((values) => ({
          ...values,
          SFTPTargetNetwork: "",
          SFTPUserName: "",
          SFTPPassword: "",
          SFTPSshHostkeyfingerprint: "",
          SFTPPortNumber: "",
          SFTPInsideWhichFolder: "",
        }));
      }
    }
  };
  const editCammunicationSubmitHandler = async (event) => {
    event.preventDefault();
    setLoader(true)
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation()
      setLoader(false);
    } else {
      // history.push('/task')
      // http://192.168.1.117:9090/api/services/UpdateConfig
      dropDownData.Client.map((item) => {
        if (item.ClientName === communication.ClientID) {
          communication.ClientID = item.Id;
        }
      });
      communication.CreatedBy = userName;
      if (communication.IsHTTP == false) {
        communication.httpPassword = "";
        communication.httpUserName = "";
        communication.httpTargetNetwork = "";
      }
      if (communication.FTP == false) {
        communication.FTPTargetNetwork = "";
        communication.FTPPassword = "";
        communication.FTPUserName = "";
        communication.FTPPortNumber = "";
      }
      if (communication.SFTP == false) {
        communication.SFTPTargetNetwork = "";
        communication.SFTPPassword = "";
        communication.SFTPUserName = "";
      }
      if (communication.IsEmail === false) {
        communication.Email = "";
      }
      if (communication.hasOwnProperty("Id") === false) {
        communication.CreatedOn =  moment(new Date()).format("L");
        getTaskId();
      } else if(communication["Id"] === "" || communication["Id"] === 0) {
        communication.CreatedOn =  moment(new Date()).format("L");
        communication.ChannelID = parseInt(communication.ChannelID);
        submitCommunication();
      }else {
        if (communication.ChannelID !== "") {
          _HttpServices
            .postData("api/Services/UpdateConfig", communication)
            .then(async (data) => {
              if (data.data) {
                setShowToaster(true);
                setLoader(false)
                if(submitAction){
                  props.setTabActiveKey('DataSecurity')
                } else {
                  props.cancelHandler(); 
                }
              }
            })
            .catch((e) => {
              setLoader(false)
            });
        }
      }
    }
    setValidated(true);
  };

  const cancelHandler = async (event) => {};
  const getTaskId = async () => {
    communication.ChannelID = parseInt(communication.ChannelID);
    submitCommunication();
  };

const getTaskDataById = async (id) => {
  await _HttpServices
      .getData(
        `api/services/EditConfig?ServiceTaskId=${id}`
      )
      .then((data) => {
      //   communication.ServiceTaskId = data.data[0].Id;
      //   communication.ChannelID = parseInt(communication.ChannelID);
        // const [communication, setCommunication] = useState(data.data[0]);
        const checkboxesObj = {
          checkEmail: data.data
              ? data.data.IsEmail
              : false,
          HTTP:
             data.data
              ? data.data.IsHTTP
              : false,
          FTP:
             data.data
              ? data.data.IsFTP
              : false,
          SFTP:
             data.data
              ? data.data.IsSFTP
              : false,
        };
        setCheckedItems(checkboxesObj)
        Object.keys(initialState).map((key) => {
          if(data.data){
            if(data.data.hasOwnProperty(key) === false){
              data.data[key] = "";
            } else if(!data.data[key] && key != "AutoApprovedStatusID"){
              data.data[key] = "";
            } else if(key === "AutoApprovedStatusID"){
                if(data.data["Id"] === 0) {
                    if((data.data["AutoApprovedStatusID"] === false || data.data["AutoApprovedStatusID"] === null || data.data["AutoApprovedStatusID"] === "" )){
                      data.data["AutoApprovedStatusID"] = true;
                    }
                    if(data.data["ClientID"] === 0 || data.data["ClientID"] === "" || data.data["ClientID"] === null){
                      data.data["ClientID"] = "The CIBD Distributors";
                    }
                }
            }
          }   
        });
        if(data.data["ServiceTaskId"] === "" || data.data["ServiceTaskId"] === null || data.data["ServiceTaskId"] === 0){
          data.data["ServiceTaskId"] = id;
        }
        let resp = data.data;
        dropDownData.Client.map((item) => {
          if (item.Id === resp.ClientID) {
            resp.ClientID = item.ClientName;
          }
        });
        setCommunication(resp);
      })
      .catch((e) => {
        const checkboxesObj = {
          checkEmail:false,
          HTTP:false,
          FTP: false,
          SFTP: false,
        };
        setCheckedItems(checkboxesObj);
        let initialStateValue = initialState;
        initialStateValue.ServiceTaskId = id;
        setCommunication(initialStateValue);
        setLoader(false)
      });
}

  const submitCommunication = () => {
    dropDownData.Client.map((item) => {
      if (item.ClientName === communication.ClientID) {
        communication.ClientID = item.Id;
      }
    });
    communication.CreatedBy = userName;
    if (communication.ChannelID !== "") {
      _HttpServices
        .postData("api/Services/CommunicationConfig", communication)
        .then( async (data) => {
          if (data.data) {
            setShowToaster(true);
            setLoader(false)
            if(submitAction){
              props.setTabActiveKey('DataSecurity')
            } else {
              props.cancelHandler(); 
            }
          }
        })
        .catch((e) => {
          setLoader(false)
        });
    }
  };
  const checkboxes = [
    {
      name: "checkEmail",
      key: "checkEmail",
      label: "Email",
      value: "checkEmail",
    },
    { name: "HTTP", key: "HTTP", label: "HTTP", value: "HTTP" },
    { name: "FTP", key: "FTP", label: "FTP", value: "FTP" },
    { name: "SFTP", key: "SFTP", label: "SFTP", value: "SFTP" },
  ];

  return (
    <div className="tab-inner">
      <Toast
        onClose={() => setShowToaster(false)}
        show={showToaster}
        delay={1500}
        autohide
        className={"custom-toaster"}
      >
        <Toast.Body>
          {editing
            ? "Successfully updated configuration."
            : "Successfully added configuration."}
        </Toast.Body>
      </Toast>
      <Form
        className="form"
        noValidate
        validated={validated}
        onSubmit={
          editing
            ? editCammunicationSubmitHandler
            : addCammunicationSubmitHandler
        }
      >
        <Row>
          <Col md={12}>
            <h5 className="h5 mt-3">Endpoints Configuration</h5>
          </Col>

          <Col md={6} hidden={true}>
              {/* {loading ? <Loader /> : null} */}
              {loader ? <Loader /> : null}
            <Form.Group>
              <Form.Label htmlFor="ClientID">
                Client Name<span className="required">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                type="text"
                disabled
                required
                name="ClientID"
                // value={communication.ClientID}
                onBlur={trimValue}
                onChange={editing ? handleEditInputChange : handleInputChange}
              >
                <option>The CIBD Distributors</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please select client.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Group>
                <Form.Label htmlFor="TaskName">
                  Task Name<span className="required">*</span>
                </Form.Label>
                <Form.Control
                as="select"
                required
                name="ServiceTaskId"
                onBlur={trimValue}
                onChange={handleOnChangeTask}
                value={communication.ServiceTaskId}
                disabled={props.viewTask ? props.viewTask : props.editDisable }
              >
                <option hidden>Select Task</option>
                {tasksData ? tasksData.length != 0 ? tasksData.map((task) => (
                  <option key={task.Id} value={task.Id}>
                    {task.TaskName}
                  </option>
                )) : null : null}
              </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Please enter task name.
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor="VendorName">
              Endpoint<span className="required">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                required
                name="ChannelID"
                onBlur={trimValue}
                onChange={editing ? handleEditInputChange : handleInputChange}
                value={communication.ChannelID}
                disabled={props.viewTask}
              >
                <option hidden>Select Endpoint</option>
                {vendorData.map((vendor) => (
                  <option key={vendor.Id} value={vendor.Id}>
                    {vendor.ChannelName}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please select endpoint name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor="AutoApprovedStatusID">
                Auto Approve
              </Form.Label>
              <div>
                  <Form.Check
                    inline
                    type="checkbox"
                    id="AutoApprovedStatusID"
                    name="AutoApprovedStatusID"
                    value={communication.AutoApprovedStatusID}
                    checked={communication.AutoApprovedStatusID}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    disabled={props.viewTask}
                  />
              </div>
              <Form.Control.Feedback type="invalid">
                Please select AutoApprove.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label htmlFor="Notification">
              Configuration<span className="required">*</span>
              </Form.Label>
              <div>
                {checkboxes.map((item) => (
                  <Form.Check
                    inline
                    type="checkbox"
                    key={item.key}
                    label={item.label}
                    id={item.name}
                    name={item.name}
                    value={item.value}
                    checked={checkedItems[item.name]}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    disabled={props.viewTask || item.name === "FTP" || item.name === "HTTP"}
                  />
                ))}
              </div>
              <Form.Control.Feedback type="invalid">
                Please select atleast configuration type.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          {checkedItems.checkEmail && (
            <Fragment>
              <Col md={12}>
                <h5 className="h5 mt-2 mb-2">Email Configuration</h5>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label htmlFor="Email">
                    Email<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.checkEmail === true ? true : false}
                    name="Email"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.Email}
                    disabled={props.viewTask}
                  />
                  <Form.Text className="text-muted">
                    You can enter multiple email ids using comma(,) or
                    semicolon(;) seperation.
                  </Form.Text>
                  <Form.Control.Feedback type="invalid">
                    Please enter email.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Fragment>
          )}
          {checkedItems.HTTP && (
            <Fragment>
              <Col md={12}>
                <h5 className="h5 mt-2 mb-2">HTTP Configuration</h5>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="httpTargetNetwork">
                    HTTP Target Network<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.HTTP === true ? true : false}
                    required
                    name="httpTargetNetwork"
                    maxLength="50"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.httpTargetNetwork}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter HTTP target network.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="httpUserName">
                    HTTP Username<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="httpUserName"
                    maxLength="50"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.httpUserName}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter HTTP username.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="httpPassword">
                    HTTP Password<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    required={checkedItems.HTTP === true ? true : false}
                    name="httpPassword"
                    maxLength="30"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.httpPassword}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter HTTP password.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="httpPortNumber">
                    HTTP Port Number
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength="20"
                    name="httpPortNumber"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.httpPortNumber}
                    disabled={props.viewTask}
                  />
                </Form.Group>
              </Col>
            </Fragment>
          )}

          {checkedItems.FTP && (
            <Fragment>
              <Col md={12}>
                <h5 className="h5 mt-2 mb-2">FTP Configuration</h5>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="FTPTargetNetwork">
                    FTP Target Network<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.FTP === true ? true : false}
                    name="FTPTargetNetwork"
                    maxLength="50"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.FTPTargetNetwork}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select FTP traget network.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="FTPUserName">
                    FTP Username<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.FTP === true ? true : false}
                    name="FTPUserName"
                    maxLength="50"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.FTPUserName}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter FTP user name.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="FTPPassword">
                    FTP Password<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    required={checkedItems.FTP === true ? true : false}
                    name="FTPPassword"
                    maxLength="30"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.FTPPassword}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select FTP password.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="FTPPrivateKeyPath">
                    FTP Private Key Path
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength="50"
                    name="FTPPrivateKeyPath"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.FTPPrivateKeyPath}
                    disabled={props.viewTask}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="FTPPortNumber">
                    FTP Port Number<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.FTP === true ? true : false}
                    name="FTPPortNumber"
                    maxLength="20"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.FTPPortNumber}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter FTP port number.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="FTPInsidewhichfolder">
                  FTP Directory Path<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="FTPInsidewhichfolder"
                    maxLength="50"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.FTPInsidewhichfolder}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter FTP directory path.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Fragment>
          )}
          {checkedItems.SFTP && (
            <Fragment>
              <Col md={12}>
                <h5 className="h5 mt-2 mb-2">SFTP Configuration</h5>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="SFTPTargetNetwork">
                    SFTP Target Network<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    maxLength="50"
                    required={checkedItems.SFTP === true ? true : false}
                    name="SFTPTargetNetwork"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.SFTPTargetNetwork}
                    disabled={props.viewTask}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter SFTP traget network.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="SFTPUserName">
                    SFTP Username<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.SFTP === true ? true : false}
                    name="SFTPUserName"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.SFTPUserName}
                    disabled={props.viewTask}
                    maxLength="30"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter SFTP username.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="SFTPPassword">
                    SFTP Password<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    required={checkedItems.SFTP === true ? true : false}
                    name="SFTPPassword"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.SFTPPassword}
                    disabled={props.viewTask}
                    maxLength="30"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter SFTP password.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="SFTPSshHostkeyfingerprint">
                    SFTP Host Key Fingerprint<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.SFTP === true ? true : false}
                    name="SFTPSshHostkeyfingerprint"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.SFTPSshHostkeyfingerprint}
                    disabled={props.viewTask}
                    maxLength="50"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter SFTP host key.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="SFTPPortNumber">
                    SFTP Port Number<span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required={checkedItems.SFTP === true ? true : false}
                    name="SFTPPortNumber"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.SFTPPortNumber}
                    disabled={props.viewTask}
                    maxLength="50"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter SFTP port number.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label htmlFor="SFTPInsideWhichFolder">
                  SFTP Directory Path
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="SFTPInsideWhichFolder"
                    onBlur={trimValue}
                    onChange={
                      editing ? handleEditInputChange : handleInputChange
                    }
                    value={communication.SFTPInsideWhichFolder}
                    disabled={props.viewTask}
                    maxLength="50"
                  />
                </Form.Group>
              </Col>
            </Fragment>
          )}

          <Col md={12}>
            <Form.Group className="text-right mt-4">
              {/* { (editing || view) ? (
                <Fragment>
                  <Button type="submit" disabled={disableBtn}>
                    <IoMdDoneAll className="icon btn-icon" />
                    Update Task
                  </Button>
                  <Button
                    variant="danger"
                    className="cancel-btn ml-3"
                    onClick={() => props.cancelHandler()}
                  >
                    <IoIosClose className="icon btn-icon" />
                    Cancel
                  </Button>
                </Fragment>
              ) : ( */}
                <Fragment>
                  {/*  disabled={submitBtnDisable} */}
                  {/* <Button type="submit" disabled={disableBtn}>
                    <IoMdDoneAll className="icon btn-icon" />
                    Submit
                  </Button> */}
                  <Button hidden={true} disabled={disableBtn} onClick={() => setSubmitAction(true)} className="ml-3" type="submit"><IoMdDoneAll className="icon btn-icon" />{editing || view ? "Update and Continue" : "Save and Continue"}</Button>
                  <Button type="submit" onClick={() => setSubmitAction(false)} disabled={disableBtn} className="ml-3"><IoMdDoneAll className="icon btn-icon" />{editing || view ? "Update" : "Submit"}</Button>
                  <Button
                    variant="danger"
                    className="cancel-btn ml-3"
                    onClick={() => props.cancelHandler()}
                  >
                    <IoIosClose className="icon btn-icon" />
                    Cancel
                  </Button>
                </Fragment>
              {/* )} */}
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.tasks.loading,
  tasks: state.tasks.tasks,
  hasErrors: state.tasks.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(CommunicationConfiguration);
